import $ from 'jquery';
import React from 'react';

import {assert} from 'Asserts';
import FilesPicker from 'components/FilesPicker';
import getTestProps from 'test/lib/cypress/getTestProps';

interface FilesPickerComponentProps {
  isDisabled?: boolean;
  getName?: (file: File) => string;
  multiple?: boolean;
  // If bulkUpload is true, all the files will be sent as a list
  // to the upload function and the component expects a single
  // promise indicating whether the bulk upload succeeded
  bulkUpload?: boolean;
  parallelism?: number;
  upload: (files: Array<File>) => JQueryPromise<void>;
  maxFiles?: number;
  fileTypes?: Array<string>;
}

interface State {
  filesPicker: FilesPicker | null;
}

export default class FilesPickerComponent extends React.Component<FilesPickerComponentProps, State> {
  rootRef = React.createRef<HTMLDivElement>();

  override state: State = {
    filesPicker: null,
  };

  override componentDidMount(): void {
    const filesPicker = new FilesPicker(this.props);
    this.setState({filesPicker}, this.renderFilesPicker);
  }

  override componentWillUnmount(): void {
    if (this.state.filesPicker != null) {
      this.state.filesPicker.remove();
    }
  }

  handleUpload({
    uploadComplete,
    allComplete,
  }: {
    uploadComplete?: () => void;
    allComplete?: () => void;
  }): JQueryPromise<unknown> | undefined {
    assert(this.state.filesPicker != null, `Called upload on filesPicker=${this.state.filesPicker}`);
    return this.state.filesPicker.handleUpload({uploadComplete, allComplete});
  }

  renderFilesPicker = (): void => {
    assert(this.state.filesPicker != null, 'Expected filesPicker to be set before rendering');
    $(this.rootRef.current!).empty().append(this.state.filesPicker.render().el);
  };

  override render(): JSX.Element {
    return <div ref={this.rootRef} {...getTestProps({component: 'FilesPickerComponent', element: 'root'})} />;
  }
}
